module.exports = __webpack_public_path__ + "static/img/pdf.8cba4fdf.svg";